<template lang="pug">
  v-row
    v-col(cols="12" sm="4" v-for="(elem, ind) in elements", :key="'elem'+elem.value")
      FreespinsGameRegularCard(:item="elem" @close="removeItem(ind)" @input="(game)=>{updateItem(ind, game)}")
</template>

<script>

  import FreespinsGameRegularCard from '@/components/cards/FreespinsGameRegularCard';

  export default {
    name: "FreespinsGameRegularCardGroup",
    components: {
      FreespinsGameRegularCard,
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      items: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() =>({
      elements: [],
    }),
    watch: {
      items: function(val){
        this.elements = val;
        this.$emit('input', this.elements);
      }
    },
    created(){
      this.elements = this.items;
    },
    methods:{
      updateItem(ind, game){
        this.elements[ind].packages = game.packages;
        this.triggerReactivityTrap();
        this.$emit('input', this.elements);
      },
      removeItem(ind){
        this.elements.splice(ind, 1);
        this.$emit('input', this.elements);
      },
      triggerReactivityTrap(){
        //triggering the reactivity
        this.elements.push('');
        this.elements.pop();
      }
    },
  }
</script>

<style lang="sass">
</style>